import { MatDialog } from '@angular/material/dialog';
import { of } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { ApplicativeErrorDialogComponent } from '../components/applicative-error-dialog/applicative-error-dialog.component';

import ApplicativeStatusCode = ApplicativeError.ApplicativeErrorStatusCodes;
import { ApplicativeError } from 'src/app/core/models/error';
import { TranslateService } from '@ngx-translate/core';

function errorTemplate(errorCode: number, description: string, translateService: TranslateService): string {
  return (
    `{"message": "Error: ${errorCode} <br>` + `Description: ${description ? translateService.instant(description) : 'No description provided'}"}`
  );
}

// opens the dialog when any handler error arise
export const errorHandlingFunction =
  (translateService: TranslateService, dialog: MatDialog, errorMessageMap: Map<number, string>) =>
  (err: HttpErrorResponse) => {
    console.error('[errorHandlingFunction]: ', err);
    if (Object.values(ApplicativeStatusCode).includes(err.status)) {
      const { error } = err;
      if (error && error.code) {
        if (errorMessageMap) {
          const appErrorDescription = errorMessageMap.get(error.code);
          if (appErrorDescription) {
            dialog.open(ApplicativeErrorDialogComponent, {
              data: errorTemplate(error.code, appErrorDescription, translateService),
            });
          } else {
            dialog.open(ApplicativeErrorDialogComponent, {
              data: errorTemplate(error.code, error.description, translateService),
            });
          }

          return of(null);
        }
      }
    }

    throw err;
  };
